const ToolboxInfo = {
  maxInstances: {
    program_button_click_event_block: 2,
    image_setter_block: 1,
    label_text_setter_block: 1,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "program_button_click_event_block",
          },
          {
            kind: "block",
            type: "image_setter_block",
          },
          {
            kind: "block",
            type: "label_text_setter_block",
            inputs: {
              value: {
                shadow: {
                  type: "text",
                },
              },
            },
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
